/**
 * Traxoft Image Voting — visual enhancements
 * ------------------------------------------
 * The app only exposes a single "title" field, so we inject a subtitle
 * directly after the .voting-title heading once the Angular component
 * finishes rendering.
 *
 * Edit VOTING_SUBTITLE below to change the copy.
 */
(function () {
  'use strict';

  var VOTING_SUBTITLE =
    'Help shape our next collection - Vote for the designs you want to see on your walls';

  var SUBTITLE_CLASS = 'voting-subtitle';

  function injectSubtitle(titleEl) {
    if (!titleEl) return;
    // Already wrapped?
    var existingWrap = titleEl.parentNode;
    if (existingWrap && existingWrap.classList && existingWrap.classList.contains('voting-text-group')) {
      return;
    }

    // Create wrapper + subtitle, then move the title inside the wrapper so
    // title and subtitle stay together in the flex/grid layout.
    var wrap = document.createElement('div');
    wrap.className = 'voting-text-group';

    var subtitle = document.createElement('p');
    subtitle.className = SUBTITLE_CLASS;
    subtitle.textContent = VOTING_SUBTITLE;

    // Insert wrapper where the title was, then move title + subtitle into it
    titleEl.parentNode.insertBefore(wrap, titleEl);
    wrap.appendChild(titleEl);
    wrap.appendChild(subtitle);
  }

  function tryInject() {
    var titles = document.querySelectorAll('traxoft-viewer .voting-title');
    titles.forEach(injectSubtitle);
    return titles.length > 0;
  }

  function init() {
    if (tryInject()) return;

    // The Angular component renders asynchronously; watch for it.
    var observer = new MutationObserver(function () {
      if (tryInject()) {
        observer.disconnect();
      }
    });
    observer.observe(document.body, { childList: true, subtree: true });

    // Safety timeout after 10s
    setTimeout(function () { observer.disconnect(); }, 10000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
